/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CanvasRouteImport } from './routes/_canvas'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PreviewTokenRouteImport } from './routes/preview.$token'
import { Route as AuthedThemeRouteImport } from './routes/_authed/theme'
import { Route as AuthedSettingsRouteImport } from './routes/_authed/settings'
import { Route as AuthedJourneysRouteImport } from './routes/_authed/journeys'
import { Route as AuthedInstallRouteImport } from './routes/_authed/install'
import { Route as AuthedHomeRouteImport } from './routes/_authed/home'
import { Route as AuthedExperiencesRouteImport } from './routes/_authed/experiences'
import { Route as AuthedAssetsRouteImport } from './routes/_authed/assets'
import { Route as AuthedAnalyticsRouteImport } from './routes/_authed/analytics'
import { Route as AuthedSegmentsIndexRouteImport } from './routes/_authed/segments.index'
import { Route as AuthedCampaignsIndexRouteImport } from './routes/_authed/campaigns.index'
import { Route as AuthedSegmentsIdRouteImport } from './routes/_authed/segments.$id'
import { Route as AuthedCampaignsIdRouteImport } from './routes/_authed/campaigns.$id'
import { Route as CanvasExperiencesIdEditRouteImport } from './routes/_canvas/experiences.$id.edit'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CanvasRoute = CanvasRouteImport.update({
  id: '/_canvas',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewTokenRoute = PreviewTokenRouteImport.update({
  id: '/preview/$token',
  path: '/preview/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedThemeRoute = AuthedThemeRouteImport.update({
  id: '/theme',
  path: '/theme',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedJourneysRoute = AuthedJourneysRouteImport.update({
  id: '/journeys',
  path: '/journeys',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedInstallRoute = AuthedInstallRouteImport.update({
  id: '/install',
  path: '/install',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedHomeRoute = AuthedHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedExperiencesRoute = AuthedExperiencesRouteImport.update({
  id: '/experiences',
  path: '/experiences',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAssetsRoute = AuthedAssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnalyticsRoute = AuthedAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSegmentsIndexRoute = AuthedSegmentsIndexRouteImport.update({
  id: '/segments/',
  path: '/segments/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCampaignsIndexRoute = AuthedCampaignsIndexRouteImport.update({
  id: '/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSegmentsIdRoute = AuthedSegmentsIdRouteImport.update({
  id: '/segments/$id',
  path: '/segments/$id',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCampaignsIdRoute = AuthedCampaignsIdRouteImport.update({
  id: '/campaigns/$id',
  path: '/campaigns/$id',
  getParentRoute: () => AuthedRoute,
} as any)
const CanvasExperiencesIdEditRoute = CanvasExperiencesIdEditRouteImport.update({
  id: '/experiences/$id/edit',
  path: '/experiences/$id/edit',
  getParentRoute: () => CanvasRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/analytics': typeof AuthedAnalyticsRoute
  '/assets': typeof AuthedAssetsRoute
  '/experiences': typeof AuthedExperiencesRoute
  '/home': typeof AuthedHomeRoute
  '/install': typeof AuthedInstallRoute
  '/journeys': typeof AuthedJourneysRoute
  '/settings': typeof AuthedSettingsRoute
  '/theme': typeof AuthedThemeRoute
  '/preview/$token': typeof PreviewTokenRoute
  '/campaigns/$id': typeof AuthedCampaignsIdRoute
  '/segments/$id': typeof AuthedSegmentsIdRoute
  '/campaigns/': typeof AuthedCampaignsIndexRoute
  '/segments/': typeof AuthedSegmentsIndexRoute
  '/experiences/$id/edit': typeof CanvasExperiencesIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/analytics': typeof AuthedAnalyticsRoute
  '/assets': typeof AuthedAssetsRoute
  '/experiences': typeof AuthedExperiencesRoute
  '/home': typeof AuthedHomeRoute
  '/install': typeof AuthedInstallRoute
  '/journeys': typeof AuthedJourneysRoute
  '/settings': typeof AuthedSettingsRoute
  '/theme': typeof AuthedThemeRoute
  '/preview/$token': typeof PreviewTokenRoute
  '/campaigns/$id': typeof AuthedCampaignsIdRoute
  '/segments/$id': typeof AuthedSegmentsIdRoute
  '/campaigns': typeof AuthedCampaignsIndexRoute
  '/segments': typeof AuthedSegmentsIndexRoute
  '/experiences/$id/edit': typeof CanvasExperiencesIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/_canvas': typeof CanvasRouteWithChildren
  '/login': typeof LoginRoute
  '/_authed/analytics': typeof AuthedAnalyticsRoute
  '/_authed/assets': typeof AuthedAssetsRoute
  '/_authed/experiences': typeof AuthedExperiencesRoute
  '/_authed/home': typeof AuthedHomeRoute
  '/_authed/install': typeof AuthedInstallRoute
  '/_authed/journeys': typeof AuthedJourneysRoute
  '/_authed/settings': typeof AuthedSettingsRoute
  '/_authed/theme': typeof AuthedThemeRoute
  '/preview/$token': typeof PreviewTokenRoute
  '/_authed/campaigns/$id': typeof AuthedCampaignsIdRoute
  '/_authed/segments/$id': typeof AuthedSegmentsIdRoute
  '/_authed/campaigns/': typeof AuthedCampaignsIndexRoute
  '/_authed/segments/': typeof AuthedSegmentsIndexRoute
  '/_canvas/experiences/$id/edit': typeof CanvasExperiencesIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/analytics'
    | '/assets'
    | '/experiences'
    | '/home'
    | '/install'
    | '/journeys'
    | '/settings'
    | '/theme'
    | '/preview/$token'
    | '/campaigns/$id'
    | '/segments/$id'
    | '/campaigns/'
    | '/segments/'
    | '/experiences/$id/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/analytics'
    | '/assets'
    | '/experiences'
    | '/home'
    | '/install'
    | '/journeys'
    | '/settings'
    | '/theme'
    | '/preview/$token'
    | '/campaigns/$id'
    | '/segments/$id'
    | '/campaigns'
    | '/segments'
    | '/experiences/$id/edit'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/_canvas'
    | '/login'
    | '/_authed/analytics'
    | '/_authed/assets'
    | '/_authed/experiences'
    | '/_authed/home'
    | '/_authed/install'
    | '/_authed/journeys'
    | '/_authed/settings'
    | '/_authed/theme'
    | '/preview/$token'
    | '/_authed/campaigns/$id'
    | '/_authed/segments/$id'
    | '/_authed/campaigns/'
    | '/_authed/segments/'
    | '/_canvas/experiences/$id/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  CanvasRoute: typeof CanvasRouteWithChildren
  LoginRoute: typeof LoginRoute
  PreviewTokenRoute: typeof PreviewTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_canvas': {
      id: '/_canvas'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof CanvasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview/$token': {
      id: '/preview/$token'
      path: '/preview/$token'
      fullPath: '/preview/$token'
      preLoaderRoute: typeof PreviewTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/theme': {
      id: '/_authed/theme'
      path: '/theme'
      fullPath: '/theme'
      preLoaderRoute: typeof AuthedThemeRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/journeys': {
      id: '/_authed/journeys'
      path: '/journeys'
      fullPath: '/journeys'
      preLoaderRoute: typeof AuthedJourneysRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/install': {
      id: '/_authed/install'
      path: '/install'
      fullPath: '/install'
      preLoaderRoute: typeof AuthedInstallRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/home': {
      id: '/_authed/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthedHomeRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/experiences': {
      id: '/_authed/experiences'
      path: '/experiences'
      fullPath: '/experiences'
      preLoaderRoute: typeof AuthedExperiencesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/assets': {
      id: '/_authed/assets'
      path: '/assets'
      fullPath: '/assets'
      preLoaderRoute: typeof AuthedAssetsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/analytics': {
      id: '/_authed/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthedAnalyticsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/segments/': {
      id: '/_authed/segments/'
      path: '/segments'
      fullPath: '/segments/'
      preLoaderRoute: typeof AuthedSegmentsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/campaigns/': {
      id: '/_authed/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof AuthedCampaignsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/segments/$id': {
      id: '/_authed/segments/$id'
      path: '/segments/$id'
      fullPath: '/segments/$id'
      preLoaderRoute: typeof AuthedSegmentsIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/campaigns/$id': {
      id: '/_authed/campaigns/$id'
      path: '/campaigns/$id'
      fullPath: '/campaigns/$id'
      preLoaderRoute: typeof AuthedCampaignsIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_canvas/experiences/$id/edit': {
      id: '/_canvas/experiences/$id/edit'
      path: '/experiences/$id/edit'
      fullPath: '/experiences/$id/edit'
      preLoaderRoute: typeof CanvasExperiencesIdEditRouteImport
      parentRoute: typeof CanvasRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedAnalyticsRoute: typeof AuthedAnalyticsRoute
  AuthedAssetsRoute: typeof AuthedAssetsRoute
  AuthedExperiencesRoute: typeof AuthedExperiencesRoute
  AuthedHomeRoute: typeof AuthedHomeRoute
  AuthedInstallRoute: typeof AuthedInstallRoute
  AuthedJourneysRoute: typeof AuthedJourneysRoute
  AuthedSettingsRoute: typeof AuthedSettingsRoute
  AuthedThemeRoute: typeof AuthedThemeRoute
  AuthedCampaignsIdRoute: typeof AuthedCampaignsIdRoute
  AuthedSegmentsIdRoute: typeof AuthedSegmentsIdRoute
  AuthedCampaignsIndexRoute: typeof AuthedCampaignsIndexRoute
  AuthedSegmentsIndexRoute: typeof AuthedSegmentsIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAnalyticsRoute: AuthedAnalyticsRoute,
  AuthedAssetsRoute: AuthedAssetsRoute,
  AuthedExperiencesRoute: AuthedExperiencesRoute,
  AuthedHomeRoute: AuthedHomeRoute,
  AuthedInstallRoute: AuthedInstallRoute,
  AuthedJourneysRoute: AuthedJourneysRoute,
  AuthedSettingsRoute: AuthedSettingsRoute,
  AuthedThemeRoute: AuthedThemeRoute,
  AuthedCampaignsIdRoute: AuthedCampaignsIdRoute,
  AuthedSegmentsIdRoute: AuthedSegmentsIdRoute,
  AuthedCampaignsIndexRoute: AuthedCampaignsIndexRoute,
  AuthedSegmentsIndexRoute: AuthedSegmentsIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface CanvasRouteChildren {
  CanvasExperiencesIdEditRoute: typeof CanvasExperiencesIdEditRoute
}

const CanvasRouteChildren: CanvasRouteChildren = {
  CanvasExperiencesIdEditRoute: CanvasExperiencesIdEditRoute,
}

const CanvasRouteWithChildren =
  CanvasRoute._addFileChildren(CanvasRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  CanvasRoute: CanvasRouteWithChildren,
  LoginRoute: LoginRoute,
  PreviewTokenRoute: PreviewTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
